import { Address } from 'models/Address/address.model';

export const defaultIngredientValue = {
  id: undefined,
  ingredientName: undefined,
  ingredientOrigin: undefined,
  bestFitProductionRegion: undefined,
  ingredientQuantity: '',
  ingredientUnit: undefined,
  address: new Address(),
  origins: [],
};

export const defaultPackageMaterial = {
  address: new Address(),
  id: undefined,
  packingMaterialName: undefined,
  packingMaterialOrigin: undefined,
  packingMaterialbestFitProductionRegion: undefined,
  packingMaterialQuantity: '',
  packingMaterialUnit: undefined,
  numberOfUnitsPerPackingMaterial: undefined,
  origins: [],
};
